module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-3.839c407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-3.jpg
// module id = kT4J
// module chunks = 1